export default __webpack_public_path__ + "static/media/661.2898273e.png";